import { useCallback } from 'react';

import { useDeviceType } from '@cian/ui-kit';

import { BlueBanner } from 'shared/components/BlueBanner';
import { GuideStartBlock } from 'shared/components/GuideStartBlock';
import { HOST_PRE_FOOTER_BANNER } from 'shared/constants/hostPreFooterBanner';
import { NBSP } from 'shared/constants/symbols';
import { FaqContainer } from 'shared/containers/Faq';
import { SocialsContainer } from 'shared/containers/Socials';
import { StepsContainer } from 'shared/containers/Steps';
import { SwitcherContainer } from 'shared/containers/Switcher';
import { useAppDispatch, useGuideAnalytics, useHostFilters } from 'shared/hooks';
import { setOfferType } from 'shared/slices';
import type { TStep } from 'shared/types/carousel';
import type { TFaqItem } from 'shared/types/faq';
import { EOfferType } from 'shared/types/features';
import type { TSocials } from 'shared/types/socials';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { filterStepsByFilters } from 'shared/utils/carousel';

export const HostContentContainer: React.FC = () => {
  const device = useDeviceType();
  const dispatch = useAppDispatch();
  const { config } = useApplicationContext();
  const { offerType } = useHostFilters();
  const { trackHowItsWorkClick } = useGuideAnalytics();

  const title = `Как эффективно размещаться на${NBSP}Циан`;
  const description = 'Расскажем, как сделать привлекательное объявление и стабильно получать брони';
  const steps = config.get<TStep[]>('b2b-marketing-guide-frontend.host.steps') ?? [];
  const filteredSteps = filterStepsByFilters(steps, { offerType });
  const faqItems = config.get<TFaqItem[] | null>('b2b-marketing-guide-frontend.host.faq');
  const faq = faqItems?.length ? <FaqContainer items={faqItems} compactTop={filteredSteps.length % 2 === 0} /> : null;
  const socialsConfig = config.get<TSocials | null>('b2b-marketing-guide-frontend.host.socials');
  const socials = socialsConfig ? <SocialsContainer socials={socialsConfig} /> : null;

  const handleOfferTypeChange = useCallback(
    (nextOfferType: EOfferType): void => {
      dispatch(setOfferType(nextOfferType));
    },
    [dispatch],
  );

  return (
    <div>
      <GuideStartBlock title={title} description={description} device={device} pageType="host" offerType={offerType} />
      <SwitcherContainer withDealType={false} offerType={offerType} onActiveOfferType={handleOfferTypeChange} />
      <StepsContainer steps={filteredSteps} pageType="host" offerType={offerType} />
      {faq}
      <BlueBanner mainBanner={HOST_PRE_FOOTER_BANNER} page onButtonClick={trackHowItsWorkClick} />
      {socials}
    </div>
  );
};
